import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-stats-value-compare',
  template: `
      <span [ngStyle]="{'color' : color }" >{{ value }}% <i [class]="arrow" ></i></span>
      `,
  styleUrls: ['./stats-value-compare.component.scss']
})
export class StatsValueCompareComponent implements OnInit {

    @Input() value: any;
    @Input() status: any;

    color: string;
    arrow: string;

    constructor() { }

    ngOnInit() {

        if(this.status == 'OK - DOI_RIGHT_PERSON'){
            this.color = (this.value < 0) ? 'red' : 'green';
            this.arrow = (this.value < 0) ? 'fa fa-arrow-down' : 'fa fa-arrow-up';
        }
        else if(this.status == 'OK - DOI_LINE_EXISTS' || this.status == 'ABSENT_SUBSCRIBER'){
            this.color = '#997a00';
            this.arrow = (this.value < 0) ? 'fa fa-arrow-down' : 'fa fa-arrow-up';
        }
        else{
            this.color = (this.value > 0) ? 'red' : 'green';
            this.arrow = (this.value < 0) ? 'fa fa-arrow-down' : 'fa fa-arrow-up';
        }

        this.value = this.value.toString().replace('-', '');
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/analytics/stats/components/stats-value-compare/stats-value-compare.component.ts